import { configureStore } from "@reduxjs/toolkit";
import createReducer from "./action/action";

const store = configureStore({
  reducer: {
    data: createReducer,
  },
});
export default store;
